import aiCall from './ai_call/AiCall';
import eventList from './event_list/eventList';
import error from './error';
import jobBoard from './job_board/jobBoard';
import jobDetail from './job_board/jobDetail';
import auth from './auth/auth';
import navbar from './navbar/navbar';
import correspondances from './miscellaneous/correspondances';
import generic from './miscellaneous/generic';
import timeFormat from './miscellaneous/timeFormat';
import table from './miscellaneous/table';
import dashboard from './dashboard/dashboard';
import dashboardWidgets from './dashboard/dashboardWidgets';
import profile from './profile/profile';
import redirect from './redirect';
import caregiverScreening from './caregiver_screening/caregiverScreening';
import caregiverInterview from './caregiver_interview/caregiverInterview';
import caregiverProfile from './caregiver_profile/caregiverProfile';
import form from './form/form';

export default {
  aiCall,
  eventList,
  error,
  jobBoard,
  jobDetail,
  auth,
  navbar,
  correspondances,
  generic,
  timeFormat,
  table,
  dashboard,
  dashboardWidgets,
  profile,
  redirect,
  caregiverScreening,
  caregiverInterview,
  caregiverProfile,
  form,
};
